import Vue from 'vue'
import Duckform from 'vue-duckform'

Vue.component('Duckform', Duckform)
